// Decode the handful of entities that show up in stored post content.
const ENTITIES: Record<string, string> = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#x27;': "'",
  '&#39;': "'",
  '&apos;': "'",
  '&nbsp;': ' '
};

/**
 * Convert stored post `content` (sanitized HTML — see useContentUIRenderer) into
 * clean plain text for <title>/description/JSON-LD. Strips tags, decodes entities,
 * drops YouTube-transcript timestamp prefixes ("0:04 : "), collapses whitespace.
 * Server-safe: pure string ops, no DOM/DOMPurify (which only runs client-side).
 * Lives in @shared/all so the client (metadata/JSON-LD) and the server (sitemap
 * content-or-attachments gate) share one implementation.
 */
export function contentToPlainText(content: string | null | undefined): string {
  if (!content) return '';
  let text = content
    // Block/line tags become a space so adjacent words don't fuse together.
    .replace(/<\/(p|div|li|h[1-6]|blockquote|tr)>/gi, ' ')
    .replace(/<br\s*\/?>/gi, ' ')
    // Drop every remaining tag (anchors, spans, img, etc.).
    .replace(/<[^>]+>/g, '');
  for (const [entity, char] of Object.entries(ENTITIES)) {
    text = text.split(entity).join(char);
  }
  text = text.replace(/&#(\d+);/g, (_, code) =>
    String.fromCharCode(Number(code))
  );
  // Transcript timestamp prefixes: "0:04 : ", "1:59:", "10:02 : "
  text = text.replace(/\b\d{1,2}:\d{2}\s*:\s*/g, '');
  return text.replace(/\s+/g, ' ').trim();
}

export function truncateText(text: string, max: number): string {
  return text.length > max ? text.slice(0, max).trimEnd() + '...' : text;
}
